module.exports = __webpack_public_path__ + "static/media/google_calendar_icon.1a316ae0.png";